import { twoFactorAuthApi } from '@api/index';
import { useQuery } from '@hooks/useQuery';
import { QUERIES } from '@query/queries';

export const useRegister2FAQuery = (enabled?: boolean) => {
  return useQuery([QUERIES.TWO_FACTOR_AUTH_REGISTER_DATA], () => twoFactorAuthApi.register(), {
    enabled,
  });
};
